import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchDoctorDashboard } from "../../services/dashboardService";

const initialState = {
  data: null,
  loading: false,
  error: null,
  live: false,
};

export const loadDoctorDashboard = createAsyncThunk(
  "dashboard/load",
  async (asOfDate, { rejectWithValue }) => {
    try {
      return await fetchDoctorDashboard(asOfDate);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    clearDashboardError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loadDoctorDashboard.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loadDoctorDashboard.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.live = true;
        state.error = null;
      })
      .addCase(loadDoctorDashboard.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to load dashboard";
        state.live = false;
      });
  },
});

export const { clearDashboardError } = dashboardSlice.actions;
export default dashboardSlice.reducer;
